<template>
    <div class="registration-view">
        <div class="registration-view__header">
            <h2 class="common__heading bottom-gap-lg">Registrations</h2>
        </div>

        <a :href="registrationUrl" target="_blank" class="btn btn--secondary btn--sm bottom-gap-sm registration-view__btn">Manage my registrations</a>
        <!-- <a href="https://www.playfootball.com.au/club-registration-search" class="btn btn--secondary btn--sm bottom-gap-sm registration-view__btn">Start a registration</a> -->
    </div>
</template>

<script>
export default {
    computed: {
        registrationUrl() {
            return window.RegistrationUrl || 'https://registration.playfootball.com.au/';
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~sass/_variables.scss';
    @import "~sass/_config.scss";
    @import "~sass/mixins/_media-query.scss";

    .registration-view {
        font-family: $font-1;

        &__label {
            font-size: 14px;
            line-height: 16px;
            color: $col-neutral--6;
        }

        &__value {
            font-size: 18px;
            line-height: 22px;
            color: $col-neutral--8;
            font-weight: 600;
        }

        @include mq(largeTablet) {
            &__header {
                display: flex;
                align-items: flex-start;
            }

            &__btn {
                margin-left: 5px;

                &:first-of-type {
                    margin-left: auto;
                }
            }

            &__label {
                font-size: 16px;
                line-height: 19px;
            }

            &__value {
                font-size: 20px;
                line-height: 27px;
            }
        }
    }
</style>